<template>
  <div
    style="max-height: calc(100vh - 450px);"
    class="mt-4 scroll-content container"
  >
    <template v-if="existingPatient == false">
      <b-row>
        <b-col sm="12" md="4" v-if="fieldsVisibility.firstName ?? true">
          <b-form-group
            label="First Name"
            :state="formErrors.firstName.length == 0 ? null : false"
            :invalid-feedback="formErrors.firstName.join(', ')"
          >
            <template v-slot:label>
              Client's Legal First Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.firstName"
              trim
              maxLength="100"
              :state="formErrors.firstName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.middleName ?? true">
          <b-form-group label="Middle Name">
            <b-form-input
              v-model="form.middleName"
              trim
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.lastName ?? true">
          <b-form-group
            label="Last Name"
            :state="formErrors.lastName.length == 0 ? null : false"
            :invalid-feedback="formErrors.lastName.join(', ')"
          >
            <template v-slot:label>
              Client's Legal Last Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.lastName"
              trim
              maxLength="100"
              :state="formErrors.lastName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.preferredName ?? true">
          <b-form-group>
            <template v-slot:label>
              Preferred Name (<small>if different than legal name</small>)
            </template>
            <b-form-input
              v-model="form.preferredName"
              trim
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4" v-if="fieldsVisibility.dob ?? true">
          <b-form-group
            label="DOB"
            :state="formErrors.dob.length == 0 ? null : false"
            :invalid-feedback="formErrors.dob.join(', ')"
          >
            <template v-slot:label>
              DOB <span class="text-danger">*</span>
            </template>
            <date-picker
              :max="new Date()"
              :locale="$i18n.locale"
              v-model="form.dob"
              :errors="formErrors.dob"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.ssn ?? true">
          <b-form-group
            label="SSN"
            :state="formErrors.ssn.length == 0 ? null : false"
            :invalid-feedback="formErrors.ssn.join(', ')"
          >
            <b-form-input
              v-model="form.ssn"
              v-facade="'###-##-####'"
              trim
              :state="formErrors.ssn.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.gender ?? true">
          <b-form-group
            label="Legal Sex"
            :state="formErrors.gender.length == 0 ? null : false"
            :invalid-feedback="formErrors.gender.join(', ')"
          >
            <v-select v-model="form.gender" :options="genders"></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4" v-if="fieldsVisibility.phone ?? true">
          <b-form-group
            label="Mobile phone"
            :state="formErrors.phone.length == 0 ? null : false"
            :invalid-feedback="formErrors.phone.join(', ')"
          >
            <template v-slot:label>
              Mobile phone
              <span class="text-danger">*</span>
            </template>
            <phone-input
              v-model="form.phone"
              trim
              :state="formErrors.phone.length == 0 ? null : false"
            ></phone-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.landLineNumber ?? true">
          <b-form-group label="Other Phone">
            <phone-input v-model="form.landLineNumber"></phone-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.contactPreference ?? true">
          <b-form-group label="I prefer to be contacted by">
            <b-form-radio-group v-model="form.contactPreference">
              <b-form-radio
                v-for="(option, index) in contactPreferences"
                :key="index"
                :value="index"
                class="mr-2"
                >{{ option }}
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.email ?? true">
          <b-form-group
            label="Email"
            :state="formErrors.email.length == 0 ? null : false"
            :invalid-feedback="formErrors.email.join(', ')"
          >
            <template v-slot:label>
              Email
              <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.email"
              trim
              maxLength="150"
              :state="formErrors.email.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" v-if="fieldsVisibility.addressLine1 ?? true">
          <b-form-group
            label="Address Line 1"
            :state="formErrors.addressLine1.length == 0 ? null : false"
            :invalid-feedback="formErrors.addressLine1.join(', ')"
          >
            <template v-slot:label>
              Address Line 1
            </template>
            <b-form-input
              v-model="form.addressLine1"
              trim
              maxLength="150"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" v-if="fieldsVisibility.addressLine2 ?? true">
          <b-form-group label="Address Line 2">
            <b-form-input
              v-model="form.addressLine2"
              trim
              maxLength="150"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4" v-if="fieldsVisibility.city ?? true">
          <b-form-group
            label="City"
            :state="formErrors.city.length == 0 ? null : false"
            :invalid-feedback="formErrors.city.join(', ')"
          >
            <template v-slot:label>
              City
            </template>
            <b-form-input
              v-model="form.city"
              trim
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.state ?? true">
          <b-form-group
            label="State"
            :state="formErrors.state.length == 0 ? null : false"
            :invalid-feedback="formErrors.state.join(', ')"
          >
            <v-select v-model="form.state" :options="states"></v-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" v-if="fieldsVisibility.zipcode ?? true">
          <b-form-group
            label="Zipcode"
            :state="formErrors.zipcode.length == 0 ? null : false"
            :invalid-feedback="formErrors.zipcode.join(', ')"
          >
            <b-form-input
              v-model="form.zipcode"
              v-facade="'#####'"
              trim
              :state="formErrors.zipcode.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4" class="mt-4">
          <b-form-checkbox v-model="form.sign">
            <span>
              I am signing up on behalf of the client
            </span>
          </b-form-checkbox>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Name"
            :state="formErrors.nameOnBehalfOf.length == 0 ? null : false"
            :invalid-feedback="formErrors.nameOnBehalfOf.join(', ')"
          >
            <template v-slot:label>
              Name <span v-if="form.sign" class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.nameOnBehalfOf"
              trim
              maxLength="100"
              :disabled="!form.sign"
              :state="formErrors.nameOnBehalfOf.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Relationship to the client"
            :state="
              formErrors.relationshipOnBehalfOf.length == 0 ? null : false
            "
            :invalid-feedback="formErrors.relationshipOnBehalfOf.join(', ')"
          >
            <template v-slot:label>
              Relationship to the client
              <span v-if="form.sign" class="text-danger">*</span>
            </template>
            <v-select
              :disabled="!form.sign"
              v-model="form.relationshipOnBehalfOf"
              :options="relationships"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="12">
          <b-form-group label="General Notes">
            <b-form-textarea
              v-model="form.generalNotes"
              rows="4"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <div style="display: flex; justify-content: end;">
        <button
          @click="nextStep"
          class="btn btn-primary px-5"
          type="submit"
          v-if="insuranceEnabled"
        >
          {{ $t("step-continue-to-insurance") }}
        </button>
        <button
            :disabled="appointmentIsSubmit"
            @click="submitAppointment"
            style="color: #FFFFFF;"
            class="btn btn-success px-5"
            type="submit"
            v-else
          >
            {{ $t("step-request-appointment") }}
          </button>
        </div>
      </template>
      <template v-else>
        <div class="container">
          <div class="d-flex justify-content-center align-items-center">
            <h4>
              Now everything is ready for your appointment request!!!
            </h4>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <button
              :disabled="appointmentIsSubmit"
            @click="submitAppointmentRequest"
            class="btn btn-success px-5 text-white my-5"
            type="submit"
          >
            Create Appointment Request
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PhoneInput from "../../controls/PhoneInput.vue";
import DatePicker from "../../controls/DatePicker.vue";
import {
  validateRequired,
  validatePhoneNumber,
  validateZipcode,
  validateSSN,
  validateEmail,
  validateDate
} from "../../../helpers/validation";
import { hasClass } from "../../../helpers/layout";
export default {
  name: "AppointmentInfoStep",
  components: { PhoneInput, DatePicker },
  props: {
    existingPatient: Boolean,
    insuranceEnabled: Boolean,
    config: Object
  },
  data() {
    return {
      form: {
        firstName: null,
        middleName: null,
        lastName: null,
        preferredName: null,
        dob: null,
        ssn: null,
        gender: null,
        phone: null,
        landLineNumber: "",
        email: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        state: null,
        zipcode: null,
        generalNotes: null,
        contactPreference: 0,
        sign: false,
        relationshipOnBehalfOf: null,
        nameOnBehalfOf: ""
      },
      formErrors: {
        firstName: [],
        middleName: [],
        lastName: [],
        dob: [],
        ssn: [],
        gender: [],
        phone: [],
        email: [],
        addressLine1: [],
        addressLine2: [],
        city: [],
        state: [],
        zipcode: [],
        relationshipOnBehalfOf: [],
        nameOnBehalfOf: []
      },
      fieldsVisibility: {},
      appointmentIsSubmit: false,
      contactPreferences: ["Mobile Phone", "Other Phone", "Both"]
    };
  },
  computed: {
    ...mapState({
      genders: state =>
        state.client.genders.map(gender => {
          return {
            label: gender.name,
            value: gender.id
          };
        }),
      states: state =>
        state.client.states.map(state => {
          return {
            label: state.name,
            value: state.id
          };
        }),
      relationships: state =>
        state.client.relationships.map(relation => {
          if (relation.name !== "Self")
            return {
              label: relation.name,
              value: relation.id
            };
        })
    })
  },
  mounted() {
    this.fetchRelationships();
    this.fieldsVisibility = JSON.parse(
      this.config.appointmentRequestYourInfoFieldsVisibility
    );
  },
  methods: {
    ...mapActions("client", ["fetchRelationships"]),
    validateClientSubmit() {
      let withoutErrors = true;

      this.formErrors.firstName = [];
      if (
        (this.form.firstName === null || this.form.firstName === "") &&
        !validateRequired(this.form.firstName)
      ) {
        this.formErrors.firstName.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.nameOnBehalfOf = [];
      if (this.form.sign && !validateRequired(this.form.nameOnBehalfOf)) {
        this.formErrors.nameOnBehalfOf.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.relationshipOnBehalfOf = [];
      if (
        this.form.sign &&
        !validateRequired(this.form.relationshipOnBehalfOf)
      ) {
        this.formErrors.relationshipOnBehalfOf.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.lastName = [];
      if (
        this.form.lastName === null &&
        !validateRequired(this.form.lastName)
      ) {
        this.formErrors.lastName.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.dob = [];
      if (this.form.dob === null && !validateRequired(this.form.dob)) {
        this.formErrors.dob.push("This field is required");
        withoutErrors = false;
      }

      if (this.form.dob && !validateDate(this.form.dob)) {
        this.formErrors.dob.push("This field must have a valid date format");
        withoutErrors = false;
      }

      this.formErrors.email = [];
      if (
        this.form.email === null ||
        this.form.email === "" ||
        (this.form.email && !validateEmail(this.form.email))
      ) {
        this.formErrors.email.push("This field must have a valid email format");
        withoutErrors = false;
      }

      this.formErrors.phone = [];
      if (this.form.phone && !validatePhoneNumber(this.form.phone)) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      this.formErrors.ssn = [];
      if (this.form.ssn && !validateSSN(this.form.ssn)) {
        this.formErrors.ssn.push("This field must have a valid SSN format");
        withoutErrors = false;
      }

      this.formErrors.zipcode = [];
      if (this.form.zipcode && !validateZipcode(this.form.zipcode)) {
        this.formErrors.zipcode.push(
          "This field must have a valid Zipcode format"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    nextStep() {
      if (!this.validateClientSubmit()) {
        return this.scrollToError();
      }
      this.$emit("setInfo", this.form);
    },
    submitAppointmentRequest() {
      this.appointmentIsSubmit = true;
      this.$emit("submitAppointmentRequest");
    },
    submitAppointment() {
      if (!this.validateClientSubmit()) {
        return this.scrollToError();
      }
      this.appointmentIsSubmit = true;
      this.$emit("submitAppointmentRequest", this.form);
    },
    scrollToError() {
      setTimeout(() => {
        let firstErrorElement = document.querySelector('[aria-invalid="true"]');
        let topPos = 0;
        while (!hasClass(firstErrorElement, "container")) {
          if (
            firstErrorElement &&
            firstErrorElement.offsetTop >= 0 &&
            firstErrorElement.offsetParent !== null
          ) {
            topPos += firstErrorElement.offsetTop;
            firstErrorElement = firstErrorElement.offsetParent;
          } else {
            break;
          }
        }
        document.querySelector("div.mt-4.scroll-content.container").scrollTop =
          topPos - 400;
      }, 200);
    }
  }
};
</script>

<style scoped>
.scroll-content {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: auto !important;
}
.scroll-content::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #dfe6e9;
  display: block !important;
}

.scroll-content::-webkit-scrollbar-thumb {
  background-color: #2196f3;
  border-radius: 10px;
}
</style>
